import React , {useState , useMemo} from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updatePanelUser } from "@/slices/panelUserSlice";
import RowActionMenu from "./RowActionMenu";

const EditableTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  userTypes,
  countryList,
  genderList,
  onBlacklistClick ,
  onUnBlacklistClick ,
  onAddRewardPoi
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [sortConfig, setSortConfig] = useState({
      key: null,
      direction: "asc",
    });
  


  const blackListUser = () => {
    const data = { is_blackList: true, id: editRowId };
    dispatch(updatePanelUser(data));
  };


  const whiteListUser = () => {
    const data = { is_blackList: false, id: editRowId };
    dispatch(updatePanelUser(data));
  };


  const goToDetailView = (id) => {
    navigate(`/panel-user/${id}`);
  };


 // ✅ HANDLE SORT
  const handleSort = (header) => {
    setSortConfig((prev) => ({
      key: header,
      direction:
        prev.key === header && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  // ✅ SORTED ROWS
  const sortedRows = useMemo(() => {
    let sorted = [...rows];

    if (!sortConfig.key) return sorted;

    sorted.sort((a, b) => {
      const aVal = a[sortConfig.key] === true ? 1 : 0;
      const bVal = b[sortConfig.key] === true ? 1 : 0;

      if (sortConfig.direction === "asc") {
        return bVal - aVal; // true first
      } else {
        return aVal - bVal; // false first
      }
    });

    return sorted;
  }, [rows, sortConfig]);

  
  return (
    <div className="tableContainer max-h-[60vh] min-h-[300px] overflow-y-auto">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            {headers?.map((header, index) => (
              <th className="p-1 text-left border" key={index}>
                <div className="flex items-center gap-1">
                {header.toUpperCase()}
                  {(
                  header === "is_read" ||
                  header === "is_active" ||
                  header === "is_emailVerified" ||
                   header === "status" ||
                    header === "is_Start" ||
                   header === "is_Finshed") && (
                  <div
                    className="ml-1 cursor-pointer flex items-center"
                  onClick={() => handleSort(header)}
                  >
                  <FontAwesomeIcon
                   icon={
                  sortConfig.key === header &&
                 sortConfig.direction === "asc"
                   ? faArrowUp
                   : faArrowDown
                  }
                 className="text-[12px] text-white"
                  />
                  </div>
                 )}

                </div>
              </th>
            ))}
            <th className="p-1 text-left border">ACTION</th>
            {/* <th className="p-1 text-left border">ACTION</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedRows.map((row) => (
            <tr key={row.id}>
              {headers.map((header) => (
                <td
                  key={header}
                  style={{
                    padding: "12px",
                    border: "1px solid #ddd",
                    textAlign: "left",
                  }}
                >
                  {editRowId === row.id && editableFields.includes(header) ? (
                    header === "is_active" ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, true)}
                            value={true}
                            color="var(--green_Main)"
                            icon={faCheck}
                          />
                        )}

                        {editedData[header] === false && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, false)}
                            color="indianred"
                            icon={faXmark}
                          />
                        )}
                      </div>
                    ) : header === "gender" ? (
                      <select
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          boxSizing: "border-box",
                          border: "1px solid",
                        }}
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        {genderList.option_List?.map((m) => (
                          <option key={m.title} value={m.title}>
                            {m.title}
                          </option>
                        ))}
                      </select>
                    ) : header === "country" ? (
                      <select
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          boxSizing: "border-box",
                          border: "1px solid",
                        }}
                      >
                        <option value="" disabled>
                          Select Country
                        </option>
                        {countryList?.result?.map((m) => (
                          <option key={m.title} value={m.title}>
                            {m.title}
                          </option>
                        ))}
                      </select>
                    ) : header === "is_blackList" ? (
                      <div>
                        {editedData[header] === false ? (
                          <div
                            className="p-1.5 text-nowrap bg-red-700 text-white cursor-pointer"
                            onClick={() => blackListUser(row.id)}
                          >
                            Blacklist user
                          </div>
                        ) : (
                          <div
                            className="p-1.5 text-nowrap bg-[var(--mainCol)] text-white cursor-pointer"
                            onClick={() => whiteListUser(row.id)}
                          >
                            Whitelist User
                          </div>
                        )}
                      </div>
                    ) : header === "accessType" ? (
                      <select
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          boxSizing: "border-box",
                          border: "1px solid",
                        }}
                      >
                        <option value="" disabled>
                          Select Access Type
                        </option>
                        {userTypes?.result?.map((m) => (
                          <option key={m.title} value={m.title}>
                            {m.title}
                          </option>
                        ))}
                      </select>
                    ) : header === "dateOfBirth" ? (
                      <input
                        type="date"
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          boxSizing: "border-box",
                          border: "1px solid",
                        }}
                      />
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) => e.key === "Enter" && handleSave()}
                        style={{
                          width: "100%",
                          padding: "6px",
                          boxSizing: "border-box",
                          border: "1px solid",
                          color: "black",
                        }}
                      />
                    )
                  ) : row[header] === true ? (
                    <FontAwesomeIcon
                      className="ml-4"
                      color="var(--green_Main)"
                      icon={faCheck}
                    />
                  ) : row[header] === false ? (
                    <FontAwesomeIcon
                      className="ml-4"
                      color="indianred"
                      icon={faXmark}
                    />
                  ) : (
                    String(row[header])
                  )}
                </td>
              ))}

              {/* Detail View button */}
              {/* <td style={{ border: "1px solid #ddd" }} className="text-center">
                <button
                  className="text-xs text-center p-1 px-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  onClick={() => goToDetailView(row.id)}
                >
                 <FontAwesomeIcon icon={faEye} />
                </button>
              </td> */}

              <td className="text-center border">
              <RowActionMenu
                row={row}
                onView={goToDetailView}
                onBlacklist={onBlacklistClick}
                onUnBlacklistClick={onUnBlacklistClick }
                onAddRewardPoi ={onAddRewardPoi}
              />
            </td>
              {/* Action buttons */}
              {/* <td style={{ border: "1px solid #ddd" }}>
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      onClick={() => handleEdit(row.id)}
                      icon={faPenToSquare}
                    />
                    <FontAwesomeIcon
                      className="ml-2 cursor-pointer"
                      onClick={() => handleLog(row.id)}
                      icon={faFileLines}
                    />
                  </div>
                )}
              </td> */}


            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EditableTable;
